import React from 'react';
import { useIntl } from 'react-intl-next';
import { useSharedPluginStateWithSelector } from '@atlaskit/editor-common/hooks';
import { toolbarInsertBlockMessages as messages } from '@atlaskit/editor-common/messages';
import { useEditorToolbar } from '@atlaskit/editor-common/toolbar';
import { ToolbarButton, ToolbarTooltip, ImageIcon } from '@atlaskit/editor-toolbar';
export var ImageButton = function ImageButton(_ref) {
  var api = _ref.api;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useSharedPluginState = useSharedPluginStateWithSelector(api, ['connectivity', 'imageUpload'], function (states) {
      var _states$connectivityS, _states$imageUploadSt;
      return {
        connectivityMode: (_states$connectivityS = states.connectivityState) === null || _states$connectivityS === void 0 ? void 0 : _states$connectivityS.mode,
        imageUploadEnabled: (_states$imageUploadSt = states.imageUploadState) === null || _states$imageUploadSt === void 0 ? void 0 : _states$imageUploadSt.enabled
      };
    }),
    connectivityMode = _useSharedPluginState.connectivityMode,
    imageUploadEnabled = _useSharedPluginState.imageUploadEnabled;
  var _useEditorToolbar = useEditorToolbar(),
    editorView = _useEditorToolbar.editorView;
  var isOffline = connectivityMode === 'offline';
  var onClick = function onClick() {
    if (editorView) {
      var _api$imageUpload;
      var state = editorView.state,
        dispatch = editorView.dispatch;
      api === null || api === void 0 || (_api$imageUpload = api.imageUpload) === null || _api$imageUpload === void 0 || _api$imageUpload.actions.startUpload()(state, dispatch);
    }
  };
  return /*#__PURE__*/React.createElement(ToolbarTooltip, {
    content: formatMessage(messages.image)
  }, /*#__PURE__*/React.createElement(ToolbarButton, {
    iconBefore: /*#__PURE__*/React.createElement(ImageIcon, {
      label: formatMessage(messages.image),
      size: "small"
    }),
    onClick: onClick,
    isDisabled: !imageUploadEnabled || isOffline
  }));
};